export const CURRENT_PROFILE_NAME = 'portaly:currentProfileName'
export const WAITING_LIST_SRC = 'portaly:waitingListSrc'
export const WAITING_LIST_AB_TEXT = 'portaly:waitingListABText'
